export enum AuthenticationProvider {
    IAM = 'IAM',
    ACTIVE_HEALTH = 'ACTIVE_HEALTH',
    IAM_EXTERNAL_IDP = 'IAM_EXTERNAL_IDP'
}
